import { useEffect, useRef } from 'react';

function MatrixMiniCanvas({ size }) {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const ctx = c.getContext('2d');
    const chars = '01アイウSC';
    const cols = Math.floor(size / 6);
    const drops = Array(cols).fill(1);
    let id;
    const draw = () => {
      ctx.fillStyle = 'rgba(0,0,0,0.15)';
      ctx.fillRect(0, 0, size, size);
      ctx.fillStyle = '#00ff41';
      ctx.font = `5px monospace`;
      drops.forEach((y, i) => {
        ctx.fillText(chars[Math.floor(Math.random()*chars.length)], i*6, y*6);
        if (y*6 > size && Math.random() > 0.95) drops[i] = 0;
        drops[i]++;
      });
    };
    id = setInterval(draw, 120);
    return () => clearInterval(id);
  }, [size]);
  return <canvas ref={ref} width={size} height={size} style={{position:'absolute',inset:0,width:'100%',height:'100%',opacity:0.45}}/>;
}

export default function AscLogo({ size = 56 }) {
  return (
    <div style={{
      width: size, height: size,
      borderRadius: Math.round(size * 0.15),
      border: '1.5px solid var(--md)',
      background: '#000',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 0 12px rgba(0,255,65,0.15)',
    }}>
      <MatrixMiniCanvas size={size}/>
      <div style={{
        position: 'relative', zIndex: 2,
        display: 'flex', alignItems: 'baseline',
        fontFamily: 'var(--display)', fontWeight: 900,
        lineHeight: 1,
      }}>
        <span style={{ fontSize: size * 0.23, color: 'var(--mm)' }}>a</span>
        <span style={{ fontSize: size * 0.40, color: 'var(--mg)', textShadow: '0 0 10px var(--mg)' }}>S</span>
        <span style={{ fontSize: size * 0.23, color: 'var(--mm)' }}>c</span>
      </div>
    </div>
  );
}
